module.exports = __webpack_public_path__ + "img/mobileapplication2.79b5ad46.png";